/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

export type CreateWebhookBodyEventsItem = typeof CreateWebhookBodyEventsItem[keyof typeof CreateWebhookBodyEventsItem];


export const CreateWebhookBodyEventsItem = {
  invoicecreated: 'invoice.created',
  invoiceupdated: 'invoice.updated',
  invoicesent: 'invoice.sent',
  invoicepaid: 'invoice.paid',
  invoiceoverdue: 'invoice.overdue',
  invoicecancelled: 'invoice.cancelled',
  invoicedeleted: 'invoice.deleted',
  invoicerestored: 'invoice.restored',
  invoicevoided: 'invoice.voided',
  invoicefinalized: 'invoice.finalized',
  customercreated: 'customer.created',
  customerupdated: 'customer.updated',
  customerdeleted: 'customer.deleted',
  customerrestored: 'customer.restored',
  customerpermanently_deleted: 'customer.permanently_deleted',
  paymentreceived: 'payment.received',
  paymentfailed: 'payment.failed',
  paymentdeleted: 'payment.deleted',
  paymentrestored: 'payment.restored',
  paymentpermanently_deleted: 'payment.permanently_deleted',
  estimatecreated: 'estimate.created',
  estimatesent: 'estimate.sent',
  estimateaccepted: 'estimate.accepted',
  estimaterejected: 'estimate.rejected',
  estimatedeleted: 'estimate.deleted',
  estimaterestored: 'estimate.restored',
  credit_notecreated: 'credit_note.created',
  credit_noteissued: 'credit_note.issued',
  credit_notevoided: 'credit_note.voided',
  credit_notedeleted: 'credit_note.deleted',
  credit_noterestored: 'credit_note.restored',
  advance_invoicecreated: 'advance_invoice.created',
  advance_invoicepaid: 'advance_invoice.paid',
  advance_invoiceapplied: 'advance_invoice.applied',
  advance_invoicevoided: 'advance_invoice.voided',
  advance_invoicedeleted: 'advance_invoice.deleted',
  advance_invoicerestored: 'advance_invoice.restored',
  itemcreated: 'item.created',
  itemupdated: 'item.updated',
  itemdeleted: 'item.deleted',
  itemrestored: 'item.restored',
  itempermanently_deleted: 'item.permanently_deleted',
  taxcreated: 'tax.created',
  taxupdated: 'tax.updated',
  taxdeleted: 'tax.deleted',
  taxrestored: 'tax.restored',
  taxpermanently_deleted: 'tax.permanently_deleted',
  recurring_invoicecreated: 'recurring_invoice.created',
  recurring_invoiceupdated: 'recurring_invoice.updated',
  recurring_invoicedeleted: 'recurring_invoice.deleted',
  recurring_invoicerestored: 'recurring_invoice.restored',
  recurring_invoicepermanently_deleted: 'recurring_invoice.permanently_deleted',
  recurring_invoicepaused: 'recurring_invoice.paused',
  recurring_invoiceresumed: 'recurring_invoice.resumed',
  recurring_invoiceinvoice_generated: 'recurring_invoice.invoice_generated',
  recurring_invoicegeneration_failed: 'recurring_invoice.generation_failed',
  recurring_invoicecompleted: 'recurring_invoice.completed',
  stripe_appconnected: 'stripe_app.connected',
  stripe_appdisconnected: 'stripe_app.disconnected',
  stripe_appsettings_updated: 'stripe_app.settings_updated',
  ordercreated: 'order.created',
  orderupdated: 'order.updated',
  orderdeleted: 'order.deleted',
  orderrestored: 'order.restored',
  orderpermanently_deleted: 'order.permanently_deleted',
  orderprocessed: 'order.processed',
  ordercancelled: 'order.cancelled',
  orderfailed: 'order.failed',
  order_integrationcreated: 'order_integration.created',
  order_integrationupdated: 'order_integration.updated',
  order_integrationdeleted: 'order_integration.deleted',
  delivery_notecreated: 'delivery_note.created',
  delivery_notesent: 'delivery_note.sent',
  delivery_notecancelled: 'delivery_note.cancelled',
  delivery_notevoided: 'delivery_note.voided',
  delivery_notedeleted: 'delivery_note.deleted',
  delivery_noterestored: 'delivery_note.restored',
  e_invoicingsubmissioncreated: 'e_invoicing.submission.created',
  e_invoicingsubmissiondelivered: 'e_invoicing.submission.delivered',
  e_invoicingsubmissionfailed: 'e_invoicing.submission.failed',
  e_invoicingsupplieronboarded: 'e_invoicing.supplier.onboarded',
  e_invoicingsupplierrejected: 'e_invoicing.supplier.rejected',
} as const;
